import {decodeJson} from "@2d-front-monorepo/core";
import {PermitId, PermitResult} from "@2d-front-monorepo/permits-business";
import {getHttpClient} from "./getHttpClient";

// An archived permit is not in permitsState - it comes from its own endpoint - so anything that
// resolves a permit by id (renewal, above all) has to be able to read one back.
//
// sessionStorage and not a module-level Map: RenewPermit redirects into the wizard with `replace`,
// and RELOADING that wizard URL has to still find the permit - a module Map dies with the document,
// and the wizard's synchronous memo would then preload nothing, silently.
// ponytail: no eviction, the tab's own lifetime is the eviction policy.
const PREFIX = "permits.read.";

/** The permit {@link fetchPermit} already read, for callers that cannot await (the wizard's memo). */
export function getCachedPermit(permitId: PermitId | undefined): PermitResult | undefined {
	if (permitId == null) {
		return undefined;
	}

	try {
		// decodeJson, not JSON.parse: it is what the http layer already runs on the wire, so
		// DateTime and long ids come back exactly as the endpoint handed them over.
		return decodeJson<PermitResult>(sessionStorage.getItem(PREFIX + permitId) ?? "");
	} catch {
		//private mode, disabled storage, or a corrupt payload
		return undefined;
	}
}

export async function fetchPermit(permitId: PermitId, signal?: AbortSignal): Promise<PermitResult> {
	const cached = getCachedPermit(permitId);
	if (cached != null) {
		return cached;
	}

	const permit = await getHttpClient().permits.read(permitId, signal);
	try {
		sessionStorage.setItem(PREFIX + permitId, JSON.stringify(permit));
	} catch {
		//storage unavailable or full - the read itself worked, only the reload path loses it
	}

	return permit;
}
